<template>
	<botao-tooltip icone="mdi-reply" cor="grey" texto="Descancelar" @click="descancelar"></botao-tooltip>
</template>

<script>
import BotaoTooltip from '@/views/components/BotaoTooltip.vue'
import { mutationTypes } from '@/core/constants'

export default {
	name: 'botao-descancelar-item-aditivo-apostila',
	components: { BotaoTooltip },
	props: {
		item: {
			type: Object,
			required: true,
		},
	},
	methods: {
		descancelar() {
			this.$store.commit(mutationTypes.ITEM_ADITIVO_APOSTILA.ITEM_ADITIVO_APOSTILA_SELECIONADO, [this.item])

			this.$emit('descancelar', false)
		},
	},
}
</script>

<style scoped lang="stylus"></style>
